/* eslint-disable */

import React from 'react';
import { OptionSelect } from '../../../../../../components/UI-Elements/Select/OptionSelect';
import { IRouteDetailsDataBlobPreset } from '../../../../../../sp-types/routeDetailsType';
import { DataBlobPresetTypes } from '@pages/Policy/RouteDetails/routeDetailsUtils';
import { RouteDetailsDataBlob } from '../RouteDetailsDataBlob';

export const InputRouteDetailsDataBlobPreset: React.FC<IRouteDetailsDataBlobPreset> = ({
  route,
  update,
  currentType,
}) => {
  const handleUpdateType = (value: string) => {
    update && update({ currentType: value });
  };

  return (
    <div className="flex flex-row gap-4">
      {Object.prototype.hasOwnProperty.call(DataBlobPresetTypes, currentType) && route && route.prices && (
        <RouteDetailsDataBlob
          icon={DataBlobPresetTypes[currentType].icon}
          dataList={DataBlobPresetTypes[currentType].getDataList(route)}
          title={currentType === 'price-main-price' ? route.name : DataBlobPresetTypes[currentType].title}
          isAlert={DataBlobPresetTypes[currentType].isAlert}
        />
      )}
      <OptionSelect
        currentOption={currentType}
        options={Object.keys(DataBlobPresetTypes)}
        setCurrentOption={(value: string) => handleUpdateType(value)}
      />
    </div>
  );
};
